export default function COUNTIFS() {
  return <div>Excel_COUNTIFS</div>;
}
